var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"bgauth",attrs:{"id":"inspire"}},[_c('v-main',[_c('v-fade-transition',{attrs:{"hide-on-leave":""}},[_c('div',{staticClass:"auth-wrapper d-flex justify-center align-center"},[_c('div',{staticClass:"auth-container px-10 py-10 rounded-lg"},[_c('router-view',{key:_vm.$route.path})],1)])]),_c('overlay-loading')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }